import { render, staticRenderFns } from "./ShengDabiaoManage.vue?vue&type=template&id=0e82bdaa&"
import script from "./ShengDabiaoManage.vue?vue&type=script&lang=js&"
export * from "./ShengDabiaoManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports